var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('TentForm',{attrs:{"data":_vm.getTentItem},on:{"submit":_vm.onSubmit,"abort":_vm.onAbort}})],1),_c('div',{staticClass:"column is-one-quarter"},[_c('div',[_c('TentUsage',{attrs:{"tent":_vm.getTentItem}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }